const SET_FULL_SCREEN = 'scratch-gui/mode/SET_FULL_SCREEN';
const SET_PLAYER = 'scratch-gui/mode/SET_PLAYER';
const SET_LINKMODE = 'scratch-gui/mode/SET_LINKMODE';
const SET_COURSE = 'scratch-gui/mode/SET_COURSE';

const initialState = {
    showBranding: false,
    isFullScreen: false,
    isPlayerOnly: false,
    hasEverEnteredEditor: true,
    linkMode: 'HID', // C1控制器当前连接方式 HID：USB线连接；BLUETOOTH：蓝牙连接
    course: {}
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SET_FULL_SCREEN:
            return Object.assign([], state, {
                isFullScreen: action.isFullScreen,
                isPlayerOnly: state.isPlayerOnly
            });
        case SET_PLAYER:
            return Object.assign([], state, {
                isFullScreen: state.isFullScreen,
                isPlayerOnly: action.isPlayerOnly,
                hasEverEnteredEditor: state.hasEverEnteredEditor || !action.isPlayerOnly
            });
        case SET_LINKMODE:
            return Object.assign([], state, {
                linkMode: action.linkMode
            });
        case SET_COURSE:
            return Object.assign({}, state, {
                course: action.value
            });
        default:
            return state;
    }
};

const setFullScreen = function (isFullScreen) {
    return {
        type: SET_FULL_SCREEN,
        isFullScreen: isFullScreen
    };
};
const setPlayer = function (isPlayerOnly) {
    return {
        type: SET_PLAYER,
        isPlayerOnly: isPlayerOnly
    };
};
const setLinkMode = function (linkMode) {
    return {
        type: SET_LINKMODE,
        linkMode: linkMode
    };
};

const setCourse = function (data) {
    return {
        type: SET_COURSE,
        value: data
    };
};
export {
    reducer as
    default,
    initialState as modeInitialState,
    setFullScreen,
    setPlayer,
    setLinkMode,
    setCourse
};
